import React from 'react';
import ClientIntakeForm from '../components/ClientIntakeForm';
import { useNavigate } from 'react-router-dom';
import { useToast } from '../components/Toast';

const mockClientData = {
  reasonForVisit: 'Annual checkup',
  symptoms: '',
  primaryConcerns: ['General health'],
  currentDoctors: [],
  medications: [],
  allergies: [],
  chronicConditions: [],
  emergencyContacts: [],
  caregiver: undefined,
  insurance: {
    provider: '',
    planType: '',
    memberId: '',
    groupNumber: '',
    copay: '',
    deductible: '',
    outOfPocketMax: ''
  },
  formsAndConsents: {
    medicalRelease: false,
    hipaaConsent: false,
    caregiverAuthorization: false
  }
};

const UpdateProfile: React.FC = () => {
  const navigate = useNavigate();
  const toast = useToast();

  const handleProfileUpdate = (data: any) => {
    // TODO: Save updated profile data to backend or state
    toast.success('Profile Updated', 'Your profile has been saved successfully.');
    console.log('Updated profile:', data);
    navigate('/client-dashboard');
  };

  return (
    <div className="app">
      <main className="page">
        <div className="container" style={{ maxWidth: 700, margin: '0 auto', padding: '2rem 1rem' }}>
          <h2 style={{ fontSize: '2rem', color: '#3b82f6', fontWeight: 700, marginBottom: '1rem', textAlign: 'center' }}>Update Profile</h2>
          <div style={{ color: 'red', textAlign: 'center', marginBottom: '1rem' }}>
            DEBUG: You are on the UpdateProfile page.
          </div>
          <div style={{ background: '#fff', borderRadius: 12, boxShadow: '0 2px 8px rgba(0,0,0,0.04)', padding: '2rem' }}>
            <ClientIntakeForm
              isInitialSetup={false}
              existingData={mockClientData}
              onSubmit={handleProfileUpdate}
            />
          </div>
        </div>
      </main>
    </div>
  );
};

export default UpdateProfile;
